export const mapDispatchToProps = (dispatch) => ({ dispatch });
